module.exports = __webpack_public_path__ + "static/media/botoes.9362ba17.png";